'use client';

import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';

export interface IWithSwiperProps {
  children({ isLocked }: { isLocked: boolean }): React.ReactNode;
}

export default function WithSwiper({ children }: IWithSwiperProps) {
  const swiper = useSwiper();
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    swiper.on('lock', () => {
      setIsLocked(swiper.isLocked);
    });
    swiper.on('unlock', () => {
      setIsLocked(swiper.isLocked);
    });
    setIsLocked(swiper.isLocked);
  }, [swiper]);

  return children({ isLocked });
}
